import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { DeleteIcon } from 'src/components/SkladonIcon/SmallIcons';

export interface TopBlockPropsType {
    newProductSet: boolean;
    disableEdit: boolean;
    permissionDelete: boolean;
    handleSave: () => void;
    handleDeleteProductSet: () => void;
    handleNavigateToProductDetail?: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        label: translate('productSetDetail.action.detail'),
                        onClick: () => {
                            props.handleNavigateToProductDetail?.();
                        },
                        hidden: props.newProductSet,
                        variant: 'outlined',
                    },
                    {
                        icon: <DeleteIcon />,
                        tooltip: translate('productSetDetail.action.delete'),
                        onClick: () => {
                            props.handleDeleteProductSet();
                        },
                        hidden: !props.permissionDelete,
                    },
                    {
                        label: translate(
                            props.newProductSet ? 'productSetDetail.action.create' : 'productSetDetail.action.save'
                        ),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
